module.exports = __webpack_public_path__ + "static/media/wow.6c323597.png";